/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2018-02-21, 09:54:04
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-02-22, 14:11:51
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */
export const FILL_BRAND_THEME = 'FILL_BRAND_THEME';



// WEBPACK FOOTER //
// ./src/store/modules/Brand/mutation-types.js